import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  successColor: {
    backgroundColor: 'rgb(0, 213, 146)',
  },
  errorColor: {
    backgroundColor: theme.palette.error.main,
  },
  progressBar: {
    height: 15,
    borderRadius: 5,
    backgroundColor: 'rgb(245,245,245)',
  },
  overflow: {
    overflow: 'auto',
    maxHeight: 132,
  },
  pauseButton: {
    minWidth: 0,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
  successMessageColor: {
    color: 'rgb(0, 213, 146)',
  },
}));
